import { keyframes } from 'styled-components';

export const focusAnimation =keyframes`
 0% { transform:rotate(0)  }
 30% { transform:rotate(-2deg)  }
 60% { transform:rotate(2deg)  } 
 100% { transform:rotate(0)  }
`